export default "__VITE_ASSET__5acf6028__"